<template>
  <div class="source-channel-management-page">
    <el-menu :default-active="activeIndex" router class="channel-menu" mode="horizontal">
      <el-menu-item
        v-for="(item, index) in tabList"
        class="menu-item"
        :key="index"
        :index="item.path"
      >
        {{ item.title || $t(item.i18nTitle) }}
      </el-menu-item>
    </el-menu>
    <router-view class="content"/>
  </div>
</template>

<script>
// import _ from 'lodash'

export default {
  components: {
  },
  props: {

  },
  data () {
    return {
      activeIndex: null,
      i18nPrefix: 'admin.customer.sourceChannelManagement'
    }
  },
  computed: {
    activeTab () {
      return this.$route.query.tab
    },
    tabList () {
      return [
        { path: '/v-admin/client-admin/source-channel/management/channel', i18nTitle: `${this.i18nPrefix}.tab.channelManagement` },
        { path: '/v-admin/client-admin/source-channel/management/code', i18nTitle: `${this.i18nPrefix}.tab.sourceCodeManagement` }
      ]
    }
  },
  methods: {

  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.activeIndex = this.$route.path
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.source-channel-management-page {
  background-color: #fff;
  padding: 30px;
  height: 100%;

  .channel-menu {
    .menu-item {
      font-size: 14px;
      line-height: 30px;
      padding: 0;
      margin: 0 20px;
      height: 30px;

      &:first-child {
        margin-left: 0;
      }
    }

    .menu-item.is-active {
      color: #0096cc;
      border-bottom: 1px solid #0096cc;
    }
  }

  .content {
    padding-top: 20px;
  }
}

</style>
